const ENV = import.meta.env.DEV ? import.meta.env.VITE_ENVIRONMENT :  process.env.VITE_ENVIRONMENT;
const TEASER_HOST_URL_SERVER_SIDE = import.meta.env.DEV ? import.meta.env.VITE_TEASER_HOST_URL_SERVER_SIDE : process.env.VITE_TEASER_HOST_URL_SERVER_SIDE;
const TOGGLES_URL = import.meta.env.DEV ? import.meta.env.VITE_TOGGLES_URL : process.env.VITE_TOGGLES_URL;
const DOMAIN = import.meta.env.DEV ? import.meta.env.VITE_DOMAIN : process.env.VITE_DOMAIN;

export const environment = {
	ENV, TEASER_HOST_URL_SERVER_SIDE, TOGGLES_URL, DOMAIN
};
